module.exports = __webpack_public_path__ + "static/fonts/iconfont.a5f583b.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/iconfont.woff?t=1487055721860
// module id = 111
// module chunks = 2